module.exports = __webpack_public_path__ + "img/title_sp.92715156.svg";